var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRecordCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.25C5.67924 0.25 4.86651 0.411661 4.10823 0.725753C3.34994 1.03984 2.66095 1.50022 2.08058 2.08058C0.90848 3.25269 0.25 4.8424 0.25 6.5C0.25 8.1576 0.90848 9.74732 2.08058 10.9194C2.66095 11.4998 3.34994 11.9602 4.10823 12.2742C4.86651 12.5883 5.67924 12.75 6.5 12.75C8.1576 12.75 9.74732 12.0915 10.9194 10.9194C12.0915 9.74732 12.75 8.1576 12.75 6.5C12.75 5.67924 12.5883 4.86651 12.2742 4.10823C11.9602 3.34994 11.4998 2.66095 10.9194 2.08058C10.3391 1.50022 9.65006 1.03984 8.89177 0.725753C8.13349 0.411661 7.32076 0.25 6.5 0.25ZM6.5 11.5C3.74375 11.5 1.5 9.25625 1.5 6.5C1.5 3.74375 3.74375 1.5 6.5 1.5C9.25625 1.5 11.5 3.74375 11.5 6.5C11.5 9.25625 9.25625 11.5 6.5 11.5ZM8.375 6.5C8.375 6.99728 8.17746 7.47419 7.82583 7.82583C7.47419 8.17746 6.99728 8.375 6.5 8.375C6.00272 8.375 5.52581 8.17746 5.17417 7.82583C4.82254 7.47419 4.625 6.99728 4.625 6.5C4.625 6.00272 4.82254 5.52581 5.17417 5.17417C5.52581 4.82254 6.00272 4.625 6.5 4.625C6.99728 4.625 7.47419 4.82254 7.82583 5.17417C8.17746 5.52581 8.375 6.00272 8.375 6.5Z",
    fill: "black",
    fillOpacity: 0.66
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordCircle);
export default __webpack_public_path__ + "static/media/RecordCircle.191b93a9.svg";
export { ForwardRef as ReactComponent };